"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatus = exports.FailureReason = void 0;
var FailureReason;
(function (FailureReason) {
    // For errors that occur while executing the export of a receipt
    FailureReason["EXPORT_RECEIPT_FAILURE"] = "EXPORT_RECEIPT_FAILURE";
    // For errors that occur while running the export consolidation function
    FailureReason["EXPORT_RECEIPT_CONVERSION_FAILURE"] = "EXPORT_RECEIPT_CONVERSION_FAILURE";
    /**
     * For when export item does not satisfy ERP requirements (eg not supported currency, missed mandatory
     * values such as account/contra-account fields for some types of export items)
     */
    FailureReason["EXPORT_ITEM_VALIDATION_FAILURE"] = "EXPORT_ITEM_VALIDATION_FAILURE";
    /**
     * For when we are unable to create an export item entity (transaction, journalLine etc depending on ERP) on 3rd party side.
     */
    FailureReason["EXPORT_ITEM_EXPORT_FAILURE"] = "EXPORT_ITEM_EXPORT_FAILURE";
    // For when the failure of the export was as a result of a timeout
    FailureReason["EXPORT_TIMEOUT_FAILURE"] = "EXPORT_TIMEOUT_FAILURE";
})(FailureReason = exports.FailureReason || (exports.FailureReason = {}));
var JobStatus;
(function (JobStatus) {
    JobStatus["CREATED"] = "CREATED";
    JobStatus["EXPORTING_EXPENSES"] = "EXPORTING_EXPENSES";
    JobStatus["EXPORTING_INVOICES"] = "EXPORTING_INVOICES";
    JobStatus["EXPORTING_RECEIPTS"] = "EXPORTING_RECEIPTS";
    JobStatus["COMPLETED"] = "COMPLETED";
    JobStatus["FAILED"] = "FAILED";
})(JobStatus = exports.JobStatus || (exports.JobStatus = {}));
//# sourceMappingURL=export-history.js.map